import { resolveImageSrc } from "../../api/axios";

export default function PR02({ module }) {
    const item = module.items[0] || {};

    return (
        <div className="w-full">

            {/* Bloc principal */}
            <div className="w-full overflow-hidden relative">

                {/* Image en background */}
                <img
                    src={resolveImageSrc(item.picture1)}
                    alt={item.alt_picture1 || ""}
                    className="absolute w-full h-full object-cover"
                />

                {/* Zone de contenu */}
                <div className="relative z-10 md:flex md:flex-row flex-col p-6">

                    <div className="md:w-2/3 bg-white bg-opacity-75 w-full px-6 py-2 flex flex-col justify-center m-auto rounded-lg backdrop-blur-sm">
                        <h2 className="text-3xl font-bold mb-2">
                            {item.title || ""}
                        </h2>

                        <div
                            className="text-gray-800 leading-relaxed text-base"
                            dangerouslySetInnerHTML={{ __html: item.description || "" }}
                        />
                    </div>

                </div>
            </div>

        </div>
    );
}
